import { render, staticRenderFns } from "./WorkplacePlaceholder.vue?vue&type=template&id=e19a34e8"
import script from "./WorkplacePlaceholder.vue?vue&type=script&lang=ts"
export * from "./WorkplacePlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./WorkplacePlaceholder.vue?vue&type=style&index=0&id=e19a34e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports